<template>
  <v-col
    v-if="$vuetify.breakpoint.name == 'xs'"
    cols="12"
    class="pa-0 align-center"
    style="height: 100vh;display: flex;margin-top: -70px;"
  >

    <h2 class="text-center">
      <v-icon x-large class="mb-5">mdi-phone-rotate-landscape</v-icon>
      <br />
      Put your phone in landscape mode
    </h2>
  </v-col>
  <v-container v-else fluid>
    <v-card class="mb-10">
      <v-row class="px-6 pt-4 pb-4">
        <date-picker
          v-model="date"
          label="Report by Date"
          style="max-width: 160px;"
        />

        <v-btn color="info" v-on:click="load()" class="mt-2" :disabled="loading" :loading="loading">Load</v-btn>
      </v-row>
    </v-card>


    <v-card class="mb-10">
      <v-toolbar flat>
        <v-toolbar-title>Total</v-toolbar-title>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="total"
        :expanded.sync="expandedRow"
        :single-expand="false"
        item-key="date"
        show-expand
        mobile-breakpoint="0"
        class="td-nowrap th-center daily-summary-table"
        hide-default-footer
      >
        <template v-slot:expanded-item="{ headers, item }">
          <td class="pa-0"></td>
          <td :colspan="headers.length-2" class="pa-0">
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                <tr>
                  <th v-for="h of subHeaders" class="text-left">{{ h.text }}</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td v-for="h of subHeaders">{{ item[h.value] }}</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>

            <v-toolbar flat>
              <v-toolbar-title>
                <v-btn
                  small
                  :outlined="expand[item.date + item.brand + item.currency + 'commission']" :text="!expand[item.date + item.brand + item.currency + 'commission']"
                  @click="expandTable(item.date + item.brand + item.currency + 'commission')"
                  class="mr-4"
                >
                  <v-icon>expand</v-icon>
                  Commissions
                </v-btn>
              </v-toolbar-title>
            </v-toolbar>
            <v-simple-table
              v-show.visible="expand[item.date + item.brand + item.currency + 'commission']"
              dense
            >
              <template v-slot:default>
                <thead>
                <tr>
                  <th v-for="h of commissionHeader" class="text-left">{{ h.text }}</th>
                </tr>
                </thead>
                <tbody>

                <tr v-for="c of item.commissions">
                  <td v-for="h of commissionHeader">
                    <template v-if="h.value == 'profit'">{{ Math.round(c.deposit - c.withdraw  - c.chargeback  - c.refund - c.commission - c.hold, 2) }}</template>
                    <template v-else-if="h.value == 'paymethod'">{{ c[h.value] }}</template>
                    <template v-else="v">{{ Math.round(c[h.value], 2)}}</template>
                  </td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </td>
          <td class="pa-0"></td>
        </template>
        <template v-slot:item.registrations="{ item }">
          {{ item.registrations.total }}<br />
          (D: {{ item.registrations.desktop }} / M: {{ item.registrations.mobile }} / A: {{ item.registrations.application }})
        </template>
        <template v-slot:item.deposit="{ item }">
          <v-tooltip
            right
            content-class="top"
          >
            <template v-slot:activator="{ attrs, on }">
              <span
                v-bind="attrs"
                v-on="on"
              >
                {{ item.deposit }}
              </span>
            </template>
            <span>
              Commission: {{ item.commission }}<br />
              Hold: {{ item.card_hold }}
            </span>
          </v-tooltip>
        </template>
        <template v-slot:item.withdraw="{ item }">
          <v-tooltip
            right
            content-class="bottom"
          >
            <template v-slot:activator="{ attrs, on }">
              <span
                v-bind="attrs"
                v-on="on"
              >
                {{ item.withdraw }}
              </span>
            </template>
            <span>
              Commission: {{ item.commission }}<br />
              Hold: {{ item.card_hold }}
            </span>
          </v-tooltip>
        </template>
        <template v-slot:item.ggr="{ item }">
          <v-tooltip
            bottom
            content-class="bottom"
          >
            <template v-slot:activator="{ attrs, on }">
              <span
                v-bind="attrs"
                v-on="on"
              >
                {{ item.ggr }}
              </span>
            </template>
            <span>
              Casino & Sport: {{ (item.ggr - item.trash_ggr).toFixed(2) }}<br />
              Test & Affiliate: {{ item.trash_ggr }}
            </span>
          </v-tooltip>
        </template>
        <template v-slot:item.ngr="{ item }">
          <v-tooltip
            bottom
            content-class="bottom"
          >
            <template v-slot:activator="{ attrs, on }">
              <span
                v-bind="attrs"
                v-on="on"
              >
                {{ item.ngr }}
              </span>
            </template>
            <span>
                NGR: {{ item.ngr }}<br />
                Extra Purchases: {{ item.extra_purchases }}
              </span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>

    <v-card class="mb-10" :key="'dr-l-' + brand" v-for="(byCurrency, brand) of items">

      <v-toolbar flat>
        <v-toolbar-title>{{ brand }}</v-toolbar-title>
      </v-toolbar>

      <div v-for="(data, currency) of byCurrency">
        <v-toolbar flat>
          <v-toolbar-title>
            <v-btn
              small
              :outlined="expand[brand + currency]" :text="!expand[brand + currency]"
              @click="expandTable(brand + currency)"
              class="mr-4"
            >
              <v-icon>expand</v-icon>
            </v-btn>
            {{ currency }}
          </v-toolbar-title>
        </v-toolbar>
        <v-data-table
          v-show.visible="expand[brand + currency]"
          :key="'dr-l-' + brand + currency"
          :headers="headers"
          :items="toArray(data)"
          item-key="date"
          class="td-nowrap th-center daily-summary-table"
          hide-default-footer
          mobile-breakpoint="0"
          show-expand
        >
          <template v-slot:expanded-item="{ headers, item }">
            <td class="pa-0"></td>
            <td
              :colspan="headers.length-2"
              class="pa-0"
            >
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th v-for="h of subHeaders" class="text-left">{{ h.text }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td v-for="h of subHeaders">
                      {{ item[h.value] }}
                    </td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>

              <v-toolbar flat>
                <v-toolbar-title>
                  <v-btn
                    small
                    :outlined="expand[brand + currency + 'commission']" :text="!expand[brand + currency + 'commission']"
                    @click="expandTable(brand + currency + 'commission')"
                    class="mr-4"
                  >
                    <v-icon>expand</v-icon>
                    Commissions
                  </v-btn>
                </v-toolbar-title>
              </v-toolbar>
              <v-simple-table
                v-show.visible="expand[brand + currency + 'commission']"
                dense
              >
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th v-for="h of commissionHeader" class="text-left">{{ h.text }}</th>
                  </tr>
                  </thead>
                  <tbody>

                  <tr v-for="c of item.commissions">
                    <td v-for="h of commissionHeader">
                      <template v-if="h.value == 'profit'">{{ Math.round(c.deposit - c.withdraw  - c.chargeback  - c.refund - c.commission - c.hold, 2) }}</template>
                      <template v-else-if="h.value == 'paymethod'">{{ c[h.value] }}</template>
                      <template v-else="v">{{ Math.round(c[h.value], 2)}}</template>
                    </td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </td>
            <td class="pa-0" />
          </template>
          <template v-slot:item.registrations="{ item }">
            {{ item.registrations.total }}
            <br />
            (D: {{ item.registrations.desktop }} / M: {{ item.registrations.mobile }} / A: {{ item.registrations.application }})
          </template>

          <template v-slot:item.deposit="{ item }">
            <v-tooltip
              right
              content-class="top"
            >
              <template v-slot:activator="{ attrs, on }">
              <span
                v-bind="attrs"
                v-on="on"
              >
                {{ item.deposit }}
              </span>
              </template>
              <span>
              Commission: {{ item.commission }}<br />
              Hold: {{ item.card_hold }}
            </span>
            </v-tooltip>
          </template>
          <template v-slot:item.withdraw="{ item }">
            <v-tooltip
              right
              content-class="bottom"
            >
              <template v-slot:activator="{ attrs, on }">
              <span
                v-bind="attrs"
                v-on="on"
              >
                {{ item.withdraw }}
              </span>
              </template>
              <span>
              Commission: {{ item.commission }}<br />
              Hold: {{ item.card_hold }}
            </span>
            </v-tooltip>
          </template>
          <template v-slot:item.ggr="{ item }">
            <v-tooltip
              bottom
              content-class="bottom"
            >
              <template v-slot:activator="{ attrs, on }">
              <span
                v-bind="attrs"
                v-on="on"
              >
                {{ item.ggr }}
              </span>
              </template>
              <span>
              Casino & Sport: {{ (item.ggr - item.trash_ggr).toFixed(2) }}<br />
              Test & Affiliate: {{ item.trash_ggr }}
            </span>
            </v-tooltip>
          </template>

          <template v-slot:item.ngr="{ item }">
            <v-tooltip
              bottom
              content-class="bottom"
            >
              <template v-slot:activator="{ attrs, on }">
              <span
                v-bind="attrs"
                v-on="on"
              >
                {{ item.ngr }}
              </span>
              </template>
              <span>
                NGR: {{ item.ngr }}<br />
                Extra Purchases: {{ item.extra_purchases || 0.00 }}
              </span>
            </v-tooltip>
          </template>

          <template v-slot:item.bet="{ item }">
            <v-tooltip
              bottom
              content-class="bottom"
            >
              <template v-slot:activator="{ attrs, on }">
              <span
                v-bind="attrs"
                v-on="on"
              >
                {{ item.bet }}
              </span>
              </template>
              <span>
              Casino & Sport: {{ (item.bet - item.trash_bet).toFixed(2) }}<br />
              Test & Affiliate: {{ item.trash_bet }}
            </span>
            </v-tooltip>
          </template>
          <template v-slot:item.win="{ item }">
            <v-tooltip
              bottom
              content-class="bottom"
            >
              <template v-slot:activator="{ attrs, on }">
              <span
                v-bind="attrs"
                v-on="on"
              >
                {{ item.win }}
              </span>
              </template>
              <span>
              Casino & Sport: {{ (item.win - item.trash_win).toFixed(2) }}<br />
              Test & Affiliate: {{ item.trash_win }}
            </span>
            </v-tooltip>
          </template>
          <template v-slot:item.bonus="{ item }">
            <v-tooltip
              bottom
              content-class="bottom"
            >
              <template v-slot:activator="{ attrs, on }">
              <span
                v-bind="attrs"
                v-on="on"
              >
                {{ item.bonus }}
              </span>
              </template>
              <span>
              Bonus Deposit: {{ (item.bonus_deposit).toFixed(2) }}<br />
              Bonus Withdraw: {{ (item.bonus_withdraw).toFixed(2) }}
            </span>
            </v-tooltip>
          </template>
        </v-data-table>
      </div>
    </v-card>


  </v-container>
</template>

<style>
  .th-center th {
    text-align: center !important;
  }

  .td-nowrap td {
    white-space: nowrap;
  }

  .v-data-table__expanded table tr th,
  .v-data-table__expanded table tr td {
    padding: 3px 5px!important;
  }

  .v-data-table tbody tr.v-data-table__expanded__content {
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
  }

  .daily-summary-table th {
    border-top: thin solid rgba(0, 0, 0, 0.12);
  }

  .daily-summary-table th,
  .daily-summary-table td {
    padding: 5px 10px!important;
    border-right: thin solid rgba(0, 0, 0, 0.12);
  }

  .daily-summary-table tr:last-child td {
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
  }

  .daily-summary-table .daily-summary-table-filter-row td {
    text-align: center;
    border-right: none;
    border-left: none;
    padding: 5px 3px!important;
  }

  .daily-summary-table .daily-summary-table-filter-row .v-input {
    margin: 0 auto !important;
  }
</style>

<script>
  import moment from 'moment'
  import { toArray } from 'lodash'
  import { API } from '@/utils/api'
  import DatePicker from '@/components/core/DatePicker/DatePicker.vue'

  export default {
    components: {
      DatePicker
    },
    data: () => ({
      loading: false,
      expand: {},
      expandedRow: [],
      total: [],
      items: {},
      currencies: {},
      date: moment().format('YYYY-MM-DD'),
      headers: [
        { text: 'Period', value: 'date', sortable: false },
        { text: 'Registrations', value: 'registrations', sortable: false },
        { text: 'Funded', value: 'funded', sortable: false },
        { text: 'Active', value: 'active_accounts', sortable: false },
        // { text: 'Games\nPlayed', value: 'bet_count', sortable: false},
        // { text: 'Avg\nBet', value: 'avg_bet', sortable: false},
        { text: 'Bet', value: 'bet', sortable: false },
        { text: 'Win', value: 'win', sortable: false },
        { text: 'FS Win', value: 'freespin_win', sortable: false },
        // { text: 'Bet\nBalance', value: 'balance_bet', sortable: false},
        // { text: 'Win\nBalance', value: 'balance_win', sortable: false},
        // { text: 'Bet\nBonus', value: 'bonus_bet', sortable: false},
        // { text: 'Win\nBonus', value: 'bonus_win', sortable: false},
        { text: 'GGR', value: 'ggr', sortable: false },
        // { text: 'GGR\nBalance', value: 'ggr_balance', sortable: false},
        // { text: 'GGR\nBonus', value: 'ggr_bonus', sortable: false},
        { text: 'NGR', value: 'ngr', sortable: false },
        { text: 'RTP %', value: 'hold', sortable: false },
        { text: 'Total\nDeposit', value: 'deposit', sortable: false },
        { text: 'Total\nWithdrawals', value: 'withdraw', sortable: false },
        { text: 'Total\nChargeback', value: 'chargeback', sortable: false },
        { text: 'Total\nRefund', value: 'refund', sortable: false },
        { text: 'Width/Dep\n%', value: 'width2dep', sortable: false },
        { text: 'Awarded\nPlayable\nBonus', value: 'bonus', sortable: false },
        { text: 'Released\nBonus', value: 'bonus_release', sortable: false },
        { text: 'Released %', value: 'bonus_release_percent', sortable: false },
        { text: 'Cash\nBonus', value: 'cash_bonus', sortable: false },
        { text: '', value: 'data-table-expand' },
      ],
      subHeaders: [
        { text: 'Commission', value: 'commission', sortable: false },
        { text: 'Correction', value: 'correction', sortable: false },
        { text: 'Extra Purchases', value: 'extra_purchases', sortable: false },
        { text: 'Card Hold', value: 'card_hold', sortable: false },
        { text: 'Games\nPlayed', value: 'bet_count', sortable: false },
        { text: 'Avg\nBet', value: 'avg_bet', sortable: false },
        { text: 'Bet\nBalance', value: 'balance_bet', sortable: false },
        { text: 'Win\nBalance', value: 'balance_win', sortable: false },
        { text: 'Bet\nBonus', value: 'bonus_bet', sortable: false },
        { text: 'Win\nBonus', value: 'bonus_win', sortable: false },
        // { text: 'FS Win', value: 'freespin_win', sortable: false },
        { text: 'GGR\nBalance', value: 'ggr_balance', sortable: false },
        { text: 'GGR\nBonus', value: 'ggr_bonus', sortable: false },
        { text: 'Bonus Deposit', value: 'bonus_deposit', sortable: false },
        { text: 'Bonus Withdraw', value: 'bonus_withdraw', sortable: false },
        { text: 'Awarded Bonuses %', value: 'bonus2dep', sortable: false },
      ],
      commissionHeader: [
        { text: 'Paymethod', value: 'paymethod', sortable: false },
        { text: 'Commission EUR', value: 'commission', sortable: false },
        { text: 'Card Hold EUR', value: 'hold', sortable: false },
        { text: 'Deposits EUR', value: 'deposit', sortable: false },
        { text: 'Withdraw EUR', value: 'withdraw', sortable: false },
        { text: 'Profit EUR', value: 'profit', sortable: false },
      ],
      data: [],

    }),
    computed: {
      brands () {
        return this.$store.state.auth.entities
      },
    },
    methods: {
      expandTable (key) {
        this.expand[key] = !this.expand[key]
        this.expand = { ...this.expand }
      },
      toArray (items) {
        return toArray(items)
      },
      load () {
        this.loading = true
        return API.call('/reports/daily_report.json', { date: this.date }).then(resp => {
          for (const k in resp.data) {
            for (const c in resp.data[k]) {
              this.expand[k + c] = false
              this.expand[k + c + 'commission'] = false
              for (const d in resp.data[k][c]) {
                this.expand[d + k + c + 'commission'] = false
              }
            }
          }
          this.items = resp.data
          this.total = toArray(resp.total)
        }).finally(() => {
          this.loading = false
        })
      },
    },
  }
</script>
